export default {"src":"/evde-internet/_next/static/media/checkbox.931a66f0.svg","height":24,"width":24};